import { CAMPAIGN_SETTINGS_OPERATIONS } from '../types/types';

export const OPERATION_OPTIONS = [
  {
    title: 'Link to',
    value: CAMPAIGN_SETTINGS_OPERATIONS.LINK_TO,
  },
];
